import { useEffect, useMemo, useState } from "react";
import { Dropdown } from "primereact/dropdown";

import { PropsWithClassName } from "../../common/types/PropsWithClassName";
import { fetchTicketStatusesByDepartment } from "./ticketStatusesApi";
import { TicketStatus, allowedTicketIncidentStatusesForSelection, allowedTicketRequestStatusesForSelection } from "./TicketStatus";
import { TicketType } from "../ticketType/TicketType";

interface TicketStatusDropdownProps extends PropsWithClassName {
  departmentId: string;
  value?: string;
  showClear?: boolean;
  onChange: (ticketStatusId?: string) => void;
  ticketType?: TicketType;
}

export default function TicketStatusDropdown({
  className,
  departmentId,
  value,
  showClear,
  onChange,
  ticketType,
}: TicketStatusDropdownProps) {
  const [departmentTicketStatuses, setDepartmentTicketStatuses] = useState<TicketStatus[]>([]);
  const ticketStatuses = useMemo(() => {
    return departmentTicketStatuses.filter((ticketStatus) => {
      if (ticketStatus.id === value) {
        return true;
      }
      return ticketType === TicketType.Incident
        ? allowedTicketIncidentStatusesForSelection.find((x) => x === ticketStatus.id)
        : allowedTicketRequestStatusesForSelection.find((x) => x === ticketStatus.id);
    });
  }, [departmentTicketStatuses, value]);
  const selectedTicketStatus = useMemo(() => ticketStatuses.find((ticketStatus) => ticketStatus.id === value), [ticketStatuses, value]);

  useEffect(() => {
    const doFetchTicketStatuses = async () => {
      if (departmentId) {
        const ticketStatuses = await fetchTicketStatusesByDepartment(departmentId);
        setDepartmentTicketStatuses(ticketStatuses);
      }
    };
    doFetchTicketStatuses();
  }, [departmentId]);

  return (
    <Dropdown
      className={`${className}`}
      scrollHeight="300px"
      optionLabel="name"
      options={ticketStatuses}
      value={selectedTicketStatus}
      showClear={showClear}
      onChange={(e) => onChange(e.value?.id)}
    />
  );
}
